var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var DEFAULT_MOCK_SSH_PORT = {
    port: 22,
};
export var DEFAULT_MOCK_SSH_PORT_RESPONSE = {
    system_ssh_port: __assign({}, DEFAULT_MOCK_SSH_PORT),
};
export var SSH_PORT_PATH = '/system/ssh_port';
